/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
class ForgotPasswordService extends __BaseService {
  static readonly forgotPasswordSendForgotPasswordLinkPath =
    "/api/ForgotPassword/SendForgotPasswordLink";
  static readonly forgotPasswordSubmitPasswordResetPath =
    "/api/ForgotPassword/SubmitPasswordReset";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param emailAddress undefined
   */
  forgotPasswordSendForgotPasswordLinkResponse(
    emailAddress?: null | string
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (emailAddress != null)
      __params = __params.set("emailAddress", emailAddress.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ForgotPassword/SendForgotPasswordLink`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param emailAddress undefined
   */
  forgotPasswordSendForgotPasswordLink(
    emailAddress?: null | string
  ): __Observable<null> {
    return this.forgotPasswordSendForgotPasswordLinkResponse(emailAddress).pipe(
      __map((_r) => _r.body as null)
    );
  }

  /**
   * @param params The `ForgotPasswordService.ForgotPasswordSubmitPasswordResetParams` containing the following parameters:
   *
   * - `resetToken`:
   *
   * - `newPassword`:
   */
  forgotPasswordSubmitPasswordResetResponse(
    params: ForgotPasswordService.ForgotPasswordSubmitPasswordResetParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.resetToken != null)
      __params = __params.set("resetToken", params.resetToken.toString());
    if (params.newPassword != null)
      __params = __params.set("newPassword", params.newPassword.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ForgotPassword/SubmitPasswordReset`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `ForgotPasswordService.ForgotPasswordSubmitPasswordResetParams` containing the following parameters:
   *
   * - `resetToken`:
   *
   * - `newPassword`:
   */
  forgotPasswordSubmitPasswordReset(
    params: ForgotPasswordService.ForgotPasswordSubmitPasswordResetParams
  ): __Observable<boolean> {
    return this.forgotPasswordSubmitPasswordResetResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
}

module ForgotPasswordService {
  /**
   * Parameters for ForgotPasswordSubmitPasswordReset
   */
  export interface ForgotPasswordSubmitPasswordResetParams {
    resetToken?: string;
    newPassword?: null | string;
  }
}

export { ForgotPasswordService };
